import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { I18nService } from '@recruitee/i18n';

@Pipe({
  name: 'rtDuration',
  standalone: true,
})
@Injectable({ providedIn: 'root' })
export class DurationPipe implements PipeTransform {
  constructor(private i18n: I18nService) {}

  // eslint-disable-next-line max-lines-per-function
  public transform(
    minutes: number,
    returnHtml: boolean = false,
    defaultValue: string = '—',
  ): string {
    const minutesPerHour = 60;
    const hourPerDay = 24;
    const minutesPerDay = minutesPerHour * hourPerDay;
    if (!minutes) {
      return defaultValue;
    }
    if (minutes < minutesPerHour) {
      return this.i18n.translate(
        returnHtml ? 'app.common.x_minutes_html' : 'app.common.x_minutes',
        {
          count: minutes,
        },
      );
    }
    if (minutes < 1410) {
      const hours = Math.round(minutes / minutesPerHour);
      return this.i18n.translate(
        returnHtml ? 'app.common.x_hours_html' : 'app.common.x_hours_plural',
        {
          count: hours,
        },
      );
    }
    if (minutes < minutesPerDay) {
      return this.i18n.translate(
        returnHtml ? 'app.common.x_days_html' : 'app.common.x_days_plural',
        {
          count: 1,
        },
      );
    }
    const days = Math.round(minutes / minutesPerDay);
    return this.i18n.translate(returnHtml ? 'app.common.x_days_html' : 'app.common.x_days_plural', {
      count: days,
    });
  }
}
